import React from "react";
import { IonItem } from "@ionic/react";

interface PositionsHeaderProps {
  aggregatedview: boolean;
}

const PositionsHeader: React.FC<PositionsHeaderProps> = ({
  aggregatedview,
}) => {
  if (aggregatedview) {
    return (
      <IonItem
        className="ion-no-padding"
        lines="none"
        style={{
          "--inner-padding-end": 0,
          "--min-height": "0px",
          "--background": "none",
          marginTop: "2px",
        }}
      >
        <div className="pg__header_agg_view_parent">
          <div
            className="pg__contract_net_pos_header"
            style={{ marginLeft: "5px" }}
          >
            CONTRACT <br /> NET POS
          </div>
          <div className="pg__buyqty_sellqty_header">
            BUY QTY
            <br />
            SELL QTY
          </div>
          <div className="pg__avgbuy_avgsell_header">
            AVG BUY
            <br />
            AVG SELL
          </div>
          <div
            className="pg__refprice_pnl_header"
            style={{ marginRight: "30px" }}
          >
            REF PRICE
            <br />
            P&L (USD)
          </div>
        </div>
      </IonItem>
    );
  }

  return (
    <IonItem
      className="ion-no-padding"
      lines="none"
      style={{
        "--inner-padding-end": 0,
        "--min-height": "0px",
        "--background": "none",
        marginTop: "2px",
      }}
    >
      <div className="pg__header_parent">
        <div className="pg__contract_net_pos_header">
          CONTRACT <br /> NET POS
        </div>
        <div className="pg__buyqty_sellqty_header">
          BUY QTY
          <br />
          SELL QTY
        </div>
        <div className="pg__avgbuy_avgsell_header">
          AVG BUY
          <br />
          AVG SELL
        </div>
        <div className="pg__refprice_pnl_header">
          REF PRICE
          <br />
          P&L (USD)
        </div>
      </div>
    </IonItem>
  );
};

export default PositionsHeader;
